/* global Vue, VueRouter, VueI18n, VeeValidate, LOYALTY_API */

import { setSuccessAndStopLoading, setErrorAndStopLoading, startLoading } from '../../apps/components/Notifications'
import { AuthService, fetchWithTokenAsync } from '../../AuthService'

export default {
  name: 'ObtainPoints',
  template: `
<div class="loyalty-obtain-points loyalty-form">
  <div class="grid">
    <div class="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
      <div class="container no-padding-md-up">
        <h2 v-html="$t('obtainPoints.title')" />
      </div>
    </div>

    <div class="col-12 col-md-10 offset-md-1 col-xl-8 offset-xl-2">
      <div class="container loyalty-form__wrapper section-margin-bottom">
        <form class="loyalty-form__border" ref="formElement">
          <h3>{{ $t('obtainPoints.formTitle') }}</h3>
          <hr>
          <div class="form-element">
            <label for="phobsId">{{ $t('obtainPoints.property') }}</label>
              <select class="select-input" id="phobsId" name="phobsId" v-model="form.phobsId" @blur="validateField('phobsId')">
                <option v-for="property in propertiesWithId" :value="property.phobsId" :text="property.title" />
              </select>
            <span class="field-error">{{ formErrors.phobsId }}</span>
          </div>

          <div class="loyalty-obtain-points__input-small">
            <div class="form-element form-element--small no-margin-bottom">
              <label for="arrivalDate">{{ $t('obtainPoints.arrivalDate') }}</label>
              <input id="arrivalDate" name="arrivalDate" type="date" v-model="form.arrivalDate" @blur="validateField('arrivalDate')" onkeydown="return false">
              <span class="field-error">{{ formErrors.arrivalDate }}</span>
            </div>
            <div class="form-element form-element--small no-margin-bottom">
              <label for="departureDate">{{ $t('obtainPoints.departureDate') }}</label>
              <input id="departureDate" name="departureDate" type="date" v-model="form.departureDate" @blur="validateField('departureDate')" onkeydown="return false">
              <span class="field-error">{{ formErrors.departureDate }}</span>
            </div>
          </div>
          <p class="no-margin-bottom">{{ $t('obtainPoints.pointsAwardedTime') }}</p>

          <div class="loyalty-obtain-points__input-small">
            <div class="form-element form-element--small">
              <label for="bookingReferenceNumber">{{ $t('obtainPoints.bookingReferenceNumber') }}</label>
              <input id="bookingReferenceNumber" name="bookingReferenceNumber" type="text" v-model="form.bookingReferenceNumber" @blur="validateField('bookingReferenceNumber')">
              <span class="field-error">{{ formErrors.bookingReferenceNumber }}</span>
            </div>
            <div class="form-element form-element--small">
              <label for="invoiceAmount">{{ $t('obtainPoints.invoiceAmount') }}</label>
              <input id="invoiceAmount" name="invoiceAmount" type="number" step="0.01" min="0" v-model="form.invoiceAmount" @blur="validateField('invoiceAmount')">
              <span class="field-error">{{ formErrors.invoiceAmount }}</span>
            </div>
          </div>

          <div class="form-element form-element--large">
            <label for="comment">{{ $t('obtainPoints.comment') }}</label>
            <textarea id="comment" name="comment" type="text" v-model="form.comment" rows="4"></textarea>
          </div>

          <p class="no-margin-bottom"><i>{{ $t('activityPointsCommon.requiredFields') }}</i></p>
        </form>

        <div class="button-group">
          <button class="button button--outline" @click="$router.push({ name: 'PointsActivity' })">{{ $t('cancel') }}</button>
          <button class="button button--maistar" @click.prevent="submitForm">{{ $t('activityPointsCommon.send') }}</button>
        </div>
      </div>
    </div>
  </div>
</div>`,
  props: {
    loyaltyId: Number,
    properties: Array,
  },
  setup (props, { emit }) {
    const router = VueRouter.useRouter()
    const { t } = VueI18n.useI18n()
    const form = Vue.reactive({})
    const formElement = Vue.ref(null)
    const formErrors = Vue.reactive({})

    const validationSchema = {
      phobsId: 'required',
      arrivalDate: 'required',
      departureDate: 'required',
      bookingReferenceNumber: 'required',
      invoiceAmount: 'reqNumber',
    }

    const propertiesWithId = Vue.computed(() => props.properties.filter(p => !!p.phobsId))

    const { handleSubmit, handleReset, errors, isSubmitting } = VeeValidate.useForm({
      validationSchema,
      initialValues: {
        phobsId: '',
      },
    })

    Vue.watch(isSubmitting, () => {
      if (Object.keys(errors).length > 0 && formElement.value) {
        const highlight = Array.from(formElement.value.querySelectorAll('.field-error')).filter(er => er.innerHTML)[0] || null
        if (highlight) { highlight.parentNode.scrollIntoView({ behavior: 'smooth' }) }
      }
    })

    const fieldRefs = Vue.reactive({})
    Object.keys(validationSchema).forEach((field) => {
      const fieldObj = VeeValidate.useField(field, undefined, {
        validateOnValueUpdate: false,
      })
      form[field] = fieldObj.value
      formErrors[field] = fieldObj.errorMessage
      fieldRefs[field] = fieldObj
    })

    const submitForm = handleSubmit(async () => {
      startLoading('obtain-points')
      try {
        const postJson = Object.assign({}, form, {
          requestType: 1,
          receiverLoyaltyId: props.loyaltyId.toString(),
        })
        const response = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/loyaltyrequests`, AuthService.accessToken, 'POST', postJson)
        if (!response?.value || response.value.length < 5) {
          throw Error('ObtainPoints')
        }
        form.comment = ''
        handleReset()
        setSuccessAndStopLoading({ details: t('obtainPoints.success'), code: 'obtainPoints' })
        router.push({ name: 'PointsActivity' })
      } catch (err) {
        setErrorAndStopLoading(err)
      }
    })

    function validateField (field) {
      fieldRefs[field].validate()
    }

    return {
      propertiesWithId,
      form,
      formElement,
      formErrors,
      submitForm,
      validateField,
    }
  },
}
